module.exports = __webpack_public_path__ + "static/media/star.77605a63.png";